import localForage from 'localforage';

localForage.config({
      driver      : localForage.INDEXEDDB,
      name        : 'dragonhub',
      version     : 2.0,
      storeName   : 'hub',
      description : 'VaultDragon Dragonhub'
    });

/* must call ready command to init indexedDB */
localForage.ready().then(() => {

  /* special case code for dealing with people using the new indexedDB
  method for the first time. This code can probably be removed in a couple
  of months after launch on production */

  localForage.getItem('vuex').then((jsonData) => {
    if ( (jsonData === null || Object.keys(jsonData.auth.user).length === 0)
          && typeof window.localStorage.vuex !== 'undefined') {
      localStorage.clear();
      sessionStorage.clear();
      indexedDB.deleteDatabase('dragonhub')
      setTimeout(() => {
        window.location = '/login';
      }, 1000);
    }
  })
})

const indexedDBDriver = {
  _driver: 'asyncStorage', // Use asyncStorage driver for IndexedDB

  async getItem(key) {
    return localForage.getItem(key);
  },

  async setItem(key, value) {
    /* await here helps ensure all observers resolve before
    setting our vuex obj in indexedDB. I noticed a speed
    improvement in vue templates rendering with their variables
    when blocking here */
    await value;
    return localForage.setItem(key, value);
  },

  async removeItem(key) {
    return localForage.removeItem(key);
  },

  async getAllKeys() {
    return localForage.keys();
  }
};

export default indexedDBDriver;
